import { createContext } from "react";

export const GrantCreateContext = createContext({});
